import React, { useEffect } from 'react'
import { Select } from '../forms'
import TagEditor from '../TagEditor'
import { tagTitles } from '../../sections/statistics/pages/ShopStatistic/headlines'
import { useTranslation } from 'react-i18next'
import { FormContainer } from './styled'
import { saveToLocalStorage } from '../../sections/statistics/utils'
import isObject from 'lodash/isObject'
import PropTypes from 'prop-types'

// When using the ProfileSettings component, you must use useReducer in conjunction with filterReducer('../../statistics/pages/filterFragments') to store all the data in one object.
const ProfileSettings = (props) => {
	const { onSelectProfile, profileData, additionalSaveTypes = {}, nameLocalStorage, ...extraOptions } = props
	const { profiles: existingProfile, value: profileName, savedSettings } = profileData
	const { additionalType1 } = additionalSaveTypes
	const [t] = useTranslation()

	useEffect(() => {
		if (!localStorage.getItem(nameLocalStorage)) {
			saveToLocalStorage(nameLocalStorage, [])
		}
		const localData = JSON.parse(localStorage.getItem(nameLocalStorage))
		const selectedProfile = localData.find(profile => profile.selected)
		if(selectedProfile) {
			isObject(selectedProfile.savedSettings) && onSelectProfile({ type: 'savedSettings', value: selectedProfile.savedSettings })
			selectedProfile.value && onSelectProfile({ type: 'value', value: selectedProfile.value })
			extraOptions[additionalType1] && onSelectProfile({ type: additionalType1, value: extraOptions[additionalType1] })
		}
		onSelectProfile({ type: 'profiles', value: localData })
	}, [])

	const handlerProfileChange = (e) => {
		let updateProfiles = []
		if(e) {
			updateProfiles = existingProfile.map(profile => {
				if(profile.id === e.id) {
					profile.selected = true
					onSelectProfile({ type: 'savedSettings', value: profile.savedSettings })
					additionalType1 && onSelectProfile({ type: additionalType1, value: profile[additionalType1] })
				} else{
					profile.selected = false
				}
				return profile
			})
			onSelectProfile({ type: 'value', value: e.value })
			onSelectProfile({ type: 'profiles', value: updateProfiles })
			saveToLocalStorage(nameLocalStorage, updateProfiles)
			return
		}
		updateProfiles = existingProfile.map(item => {
			item.selected = false
			return item
		})
		saveToLocalStorage(nameLocalStorage, updateProfiles)
		onSelectProfile({ type: 'profiles', value: updateProfiles })
		onSelectProfile({ type: 'savedSettings', value: {} })
		onSelectProfile({ type: 'value', value: null })
		additionalType1 && onSelectProfile({ type: additionalType1, value: false })
	}
	const actions = {
		handlerCreate({ value, setValue }) {
			if(value) {
				const updateProfiles = existingProfile.map(profile => {
					profile.selected = false
					return profile
				})
				updateProfiles.push({
					id: Date.now(),
					selected: true,
					value,
					savedSettings,
					...extraOptions
				})
				onSelectProfile({ type: 'value', value: value })
				onSelectProfile({ type: 'profiles', value: updateProfiles })
				setValue('')
				saveToLocalStorage(nameLocalStorage, updateProfiles)
			}
		},
		handlerUpdate(value, currentName) {
			if(currentName) {
				const updateProfiles = [...existingProfile]
				const index = updateProfiles.findIndex(item => item.id === value.id)
				updateProfiles[index].value = currentName
				onSelectProfile({ type: 'value', value: currentName })
				onSelectProfile({ type: 'profiles', value: updateProfiles })
				saveToLocalStorage(nameLocalStorage, updateProfiles)
			}
		},
		handlerDelete(value) {
			if(value) {
				const updateProfiles = [...existingProfile]
				const index = updateProfiles.findIndex(item => item.id === value.id)
				updateProfiles.splice(index, 1)
				saveToLocalStorage(nameLocalStorage, updateProfiles)
				onSelectProfile({ type: 'profiles', value: updateProfiles })
				if(updateProfiles.length === 0) {
					onSelectProfile({ type: 'value', value: null })
				}
			}
		}
	}
	return (
		<FormContainer>
			<div>
				<Select
					noForm
					inline
					style={{ width: '200px' }}
					field='tagId'
					isClearable
					labelField='value'
					value={ profileName }
					options={ existingProfile }
					label={t('statistic_section.strings.user_settings')}
					onChange={ handlerProfileChange }
					placeholder={t('statistic_section.placeholders.default')}
					usePlaceholder
				/>
				<TagEditor fieldsSelect={ existingProfile } tagTitles={tagTitles(t)} customActions={actions} />
			</div>
		</FormContainer>
	)
}

ProfileSettings.propTypes = {
	onSelectProfile: PropTypes.func,
	additionalSaveTypes: PropTypes.object,
	nameLocalStorage: PropTypes.string,
	profileData: PropTypes.shape({
		profiles: PropTypes.array,
		savedSettings: PropTypes.object
	})
}

export default ProfileSettings
